module.exports = __webpack_public_path__ + "img/man_walk.b4582a88.png";